import Row from '@amzn/meridian/row';
import React, { FC } from 'react';
import { Button, TranslationFunction } from '../../../components/blocks/localization';

// The review page's Discard, Cancel and Submit actions, or Cancel and Re-open for a discarded draft.

export type PoReviewFooterActionsProps = {
    t: TranslationFunction;
    // True when the draft was discarded, so it can only be re-opened.
    isDiscardedDraft: boolean;
    isSubmitDisabled: boolean;
    isSubmitBusy: boolean;
    isDiscardBusy: boolean;
    isReopenBusy: boolean;
    onDiscard: () => void;
    onCancel: () => void;
    onSubmit: () => void;
    onReopen: () => void;
    dataTestIdPrefix: string;
};

const PoReviewFooterActions: FC<PoReviewFooterActionsProps> = ({
    t,
    isDiscardedDraft,
    isSubmitDisabled,
    isSubmitBusy,
    isDiscardBusy,
    isReopenBusy,
    onDiscard,
    onCancel,
    onSubmit,
    onReopen,
    dataTestIdPrefix,
}) => (
    <Row alignmentHorizontal={'right'}>
        {!isDiscardedDraft && (
            <Button
                type={'tertiary'}
                disabled={isSubmitDisabled || isSubmitBusy}
                isBusy={isDiscardBusy}
                onClick={onDiscard}
                data-testid={`${dataTestIdPrefix}.discardButton`}
            >
                {t('discardPurchaseOrder-buttonLabel')}
            </Button>
        )}
        <Button type={'secondary'} onClick={onCancel} data-testid={`${dataTestIdPrefix}.cancelButton`}>
            {t('cancel-buttonLabel')}
        </Button>
        {isDiscardedDraft ? (
            <Button
                type={'primary'}
                isBusy={isReopenBusy}
                onClick={onReopen}
                data-testid={`${dataTestIdPrefix}.reopenButton`}
            >
                {t('reopenPurchaseOrder-buttonLabel')}
            </Button>
        ) : (
            <Button
                type={'primary'}
                disabled={isSubmitDisabled || isDiscardBusy}
                isBusy={isSubmitBusy}
                onClick={onSubmit}
                data-testid={`${dataTestIdPrefix}.submitButton`}
            >
                {t('submitPurchaseOrder-buttonLabel')}
            </Button>
        )}
    </Row>
);

export { PoReviewFooterActions };
